/** @format */

import React from 'react';
import { useTranslation } from 'react-i18next/hooks';

function Terms() {
	const [t] = useTranslation('translation');

	return (
		<div>
			<section style={{ width: '60%' }}>
				<div className={'verticalSpace12'} />

				<div className='info'>
					<h1 style={{ textAlign: 'center' }}>{t('termsHeading')}</h1>

					<h3>{t('termsSection1_heading')}</h3>
					<p>{t('termsSection1_1')}</p>
					<p>{t('termsSection1_2')}</p>
					<p>{t('termsSection1_3')}</p>

					<h3>{t('termsSection2_heading')}</h3>
					<p>{t('termsSection2_1')}</p>
					<p>{t('termsSection2_2')}</p>
					<p>{t('termsSection2_3')}</p>
					<p>{t('termsSection2_4')}</p>

					<h3>{t('termsSection3_heading')}</h3>
					<p>{t('termsSection3_1')}</p>
					<p>{t('termsSection3_2')}</p>
					<p>{t('termsSection3_3')}</p>

					<h3>{t('termsSection4_heading')}</h3>
					<p>{t('termsSection4_1')}</p>
					<p>{t('termsSection4_2')}</p>
					<p>{t('termsSection4_3')}</p>
					<p>{t('termsSection4_4')}</p>

					<h3>{t('termsSection5_heading')}</h3>
					<p>{t('termsSection5_1')}</p>
					<ul>
						<li>{t('termsSection5_list1')}</li>
						<li>{t('termsSection5_list2')}</li>
						<li>{t('termsSection5_list3')}</li>
					</ul>
					<p>{t('termsSection5_2')}</p>
					<p>{t('termsSection5_3')}</p>
					<p>{t('termsSection5_4')}</p>

					<h3>{t('termsSection6_heading')}</h3>
					<p>{t('termsSection6_1')}</p>
				</div>
			</section>
		</div>
	);
}

export default Terms;
